/* Scaling a slide to the screen it is shown on.

   A slide always fits. Not because its content is short, but because it is
   scaled to the projector in front of it — and scaled **both ways**: down until
   it fits, and up until it fills. Before the deck did the second half, a sparse
   slide used a third of the projector and floated in the middle of it.

   Two things make this a search rather than a division:

     zoom re-wraps text, so height does not scale linearly with it;
     the cap is real. MAX_UP stops a slide with three words on it from growing
     until the type eats every free pixel — a sparse slide is supposed to have
     air in it, and hierarchy comes from big steps between levels, not from one
     enormous level.

   OWNED BY ITEM 8 OF docs/plan/00-prestavba-2026-08.md. */

export const MIN_ZOOM = 0.34;
export const MAX_UP = 1.2;

export function fitSlide(box: HTMLElement, avail: number): void {
  if (avail < 140) return;

  let lo = MIN_ZOOM, hi = MAX_UP, best = MIN_ZOOM;
  for (let i = 0; i < 8; i++) {
    const mid = Math.round(((lo + hi) / 2) * 1000) / 1000;
    // `zoom` is not in the typed CSS declaration everywhere, and it is the
    // property that matters here: transform would scale without re-wrapping.
    box.style.setProperty("zoom", String(mid));
    if (box.getBoundingClientRect().height <= avail) { best = mid; lo = mid; }
    else hi = mid;
  }
  box.style.setProperty("zoom", String(best));
}
